import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import { request } from '../../../_network/request'
import { billingAccountConfigsURLs, supportedPaymentsURLs } from '../../../_network/apiUrls'
import GeneralConfigWrapper from './GeneralConfigWrapper'
import PaymentMethodsWrapper from './PaymentMethodsWrapper'
import OpenStackServicesWrapper from './OpenStackServicesWrapper'
import PermissionsWrapper from './PermissionsWrapper'

const BillingWrapper = (props) => {
  const {
    backendServices,
    billingServices,
    backendBillingServices,
    subscriptionServices,
    supportedServiceConfigs,
    billingServicesConfigurable,
    setFetchServices,
    subscriptionGroupNames,
  } = props
  const theme = useTheme()

  const account_id = useSelector(state => state.profile.account_id)

  const [supportedPaymentMethods, setSupportedPaymentMethods] = useState([])
  const [accountConfigs, setAccountConfigs] = useState(null)
  const [fetchAccountConfigs, setFetchAccountConfigs] = useState(1)

  const labelStyle = {
    color: theme.palette.vodka,
    fontSize: '18px',
    fontWeight: '500',
  }

  const labelArrowStyle = {
    color: theme.palette.oxfordBlue,
  }

  useEffect(() => {
    const fetchSupportedPaymentMehodsData = async () => {
      const url = constants.billing_url + '/' + supportedPaymentsURLs.getSupportedPaymentMethods
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSupportedPaymentMethods(response.data)

        // setSupportedPaymentMethods([
        //   response.data[0],
        //   {
        //     id: 'stripe123',
        //     name: 'stripe',
        //     display_name: 'Stripe Payment',  
        //     currencies: [
        //       { name: 'eur', code: '978', },
        //       { name: 'usd', code: '840', },
        //     ],
        //     config_params: { secret_key: '' },
        //   }
        // ])
      } else {
        setSupportedPaymentMethods([])
      }
    }

    fetchSupportedPaymentMehodsData()
  }, [])

  useEffect(() => {
    const fetchAccountConfigsData = async () => {
      const url = constants.billing_url + '/' + billingAccountConfigsURLs.getAccountConfigs
      const request_data = { url, method: 'GET', headers: { 'customer-account-id': account_id } }
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data) {
        setAccountConfigs(response.data)
      } else {
        setAccountConfigs(null)
      }
    }

    fetchAccountConfigsData()
  }, [account_id, fetchAccountConfigs])
  
  return (
    <>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='flex-start'
        spacing={3}
        sx={{
          padding: '20px 0px 40px 20px',
        }}
      >
        <Box sx={labelStyle}>{defaultTexts.configuration}</Box>
        <ArrowForwardIosIcon fontSize='small' sx={labelArrowStyle} />
        <Box sx={labelStyle}>{defaultTexts.billingService}</Box>
      </Stack>
      
      <Box sx={{ padding: '0px 10px' }}>
        
        <GeneralConfigWrapper
          setFetchAccountConfigs={setFetchAccountConfigs}
          accountConfigs={accountConfigs}
          supportedPaymentMethods={supportedPaymentMethods}
          subscriptionGroupNames={subscriptionGroupNames}
        />

        <PaymentMethodsWrapper
          setFetchAccountConfigs={setFetchAccountConfigs}
          accountConfigs={accountConfigs}
          supportedPaymentMethods={supportedPaymentMethods}
        />

        <OpenStackServicesWrapper
          backendServices={backendServices}
          billingServices={billingServices}
          subscriptionServices={subscriptionServices}
          supportedServiceConfigs={supportedServiceConfigs}
          billingServicesConfigurable={billingServicesConfigurable}
          setFetchServices={setFetchServices}
        />

        <PermissionsWrapper
          backendBillingServices={backendBillingServices}
          setFetchServices={setFetchServices}
        />

      </Box>      
    </>
  )
}

export default BillingWrapper